import { render } from "./SidebarCollapsableItem.vue?vue&type=template&id=64ce4333&scoped=true&ts=true"
import script from "./SidebarCollapsableItem.vue?vue&type=script&lang=ts"
export * from "./SidebarCollapsableItem.vue?vue&type=script&lang=ts"

import "./SidebarCollapsableItem.vue?vue&type=style&index=0&id=64ce4333&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ce4333"]])

export default __exports__